<template>
    <q-select
        outlined
        :modelValue="modelValue"
        :label="label"
        @update:modelValue="$emit('update:modelValue', $event)"
        use-input
        hide-selected
        fill-input
        :options="options"
        :error="error"
        :loading="loading"
        @filter="filterFn"
        :disable="loading"
        emit-value
        map-options
    >
        <template v-slot:no-option>
            <q-item>
                <q-item-section class="text-grey"> No results </q-item-section>
            </q-item>
        </template>
        <template v-slot:error>
            <span v-for="err in errors" :key="err">{{ err }}</span>
        </template>
    </q-select>
</template>

<script setup>
import { computed, ref, onMounted } from "vue";
import TablaGenericaService from "@/services/TablaGenericaService";

const props = defineProps({
    modelValue: [String, Number, Object],
    errors: [String, Array],
    label: [String],
    tipo: [String],
});
defineEmits(["update:modelValue"]);
const options = ref([]);
const error = computed(() => props?.errors && props?.errors?.length !== 0);
const loading = ref(false);
let defaultOptions = [];
const filterFn = (val, update) => {
    update(() => {
        const needle = val.toLowerCase();
        options.value = defaultOptions.filter(
            (v) => v.label.toLowerCase().indexOf(needle) > -1
        );
    });
};
onMounted(async () => {
    loading.value = true;
    defaultOptions = await TablaGenericaService.provincias();
    options.value = defaultOptions;
    loading.value = false;
});
</script>
